import { KeyboardArrowLeft } from "@mui/icons-material";
import React, { useCallback } from "react";

import EmailVerification, {
  VerifyEmailResponse,
} from "components/EmailVerification";
import { AUTH_TOKEN, AUTH_USER } from "constants/constants";
import { Plan } from "models/Payment";
import { getUser } from "utils/helper";

import styles from "./VerifyEmail.module.scss";

interface VerifyEmailProps {
  plan: Plan;
  onBack: () => void;
  onVerified: () => void;
}

const VerifyEmail: React.FC<VerifyEmailProps> = ({
  plan,
  onBack,
  onVerified,
}) => {
  const user = getUser();

  const handleVerified = useCallback(
    (res?: VerifyEmailResponse) => {
      if (res) {
        localStorage.setItem(AUTH_TOKEN, res.token);
        localStorage.setItem(AUTH_USER, JSON.stringify(res.data));
      }
      onVerified();
    },
    [onVerified],
  );

  if (!user) return null;

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.back} onClick={onBack}>
          <KeyboardArrowLeft className={styles.arrowLeft} />
          <span>Back</span>
        </div>

        <div className={styles.content}>
          <EmailVerification
            email={user.email}
            userId={user.id}
            title="Verify your email to continue"
            submitText="Verify & Continue"
            onVerified={handleVerified}
          />
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
